<template>
  <div v-if="isOpen" class="modal modal-open">
    <div :class="['modal-box', sizeClass]">
      <!-- Header with title and close button -->
      <div class="flex justify-between items-center mb-4">
        <h3 class="font-bold text-lg">{{ title }}</h3>
        <button @click="closeModal" class="btn btn-sm btn-circle btn-ghost">
          ✕
        </button>
      </div>

      <!-- Content slot -->
      <div class="py-4">
        <slot></slot>
      </div>

      <!-- Footer slot (optional) -->
      <div v-if="$slots.footer" class="modal-action">
        <slot name="footer"></slot>
      </div>
    </div>

    <!-- Backdrop -->
    <div class="modal-backdrop" @click="closeModal"></div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "Modal",
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  // "default" keeps DaisyUI's standard modal-box width; "wide" is for
  // content that needs more horizontal room (e.g. data tables).
  size: {
    type: String,
    default: "default",
  },
});

const sizeClasses = {
  default: "",
  wide: "max-w-4xl",
};

const sizeClass = computed(() => sizeClasses[props.size] || "");

const emit = defineEmits(["close"]);

const closeModal = () => {
  emit("close");
};
</script>
